import React from "react";

import { MdmObject } from "gql/generated/types";
import L, { LatLngBounds, LatLngTuple } from "leaflet";
import { Marker, Popup, ZoomControl, useMap } from "react-leaflet";
import { Link, useParams } from "react-router-dom";

/* eslint-disable global-require */
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png").default,
  iconUrl: require("leaflet/dist/images/marker-icon.png").default,
  shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
});

type ObjectMapContentProps = {
  objects: MdmObject[];
};

const ObjectMapContent: React.FC<ObjectMapContentProps> = ({ objects }) => {
  const { projectId } = useParams();
  const map = useMap();
  map.fitBounds([
    [54.2, 23.5],
    [56.2, 24.5],
  ]);

  const markers = objects?.reduce((tuples, object) => {
    if (!object?.location?.latitude || !object?.location?.longitude) return tuples;
    tuples.push([object?.location?.latitude, object?.location?.longitude]);
    return tuples;
  }, [] as LatLngTuple[]);
  
  if (markers.length === 1) {
    map.setView(markers[0], 16);
  };

  if (markers.length > 1) {
    const bounds = new LatLngBounds(markers);
    const northEast = Object.values(bounds.getNorthEast()) as LatLngTuple;
    const southWest = Object.values(bounds.getSouthWest()) as LatLngTuple;
    map.fitBounds([northEast, southWest]);
  }

  const mapMarkers = objects?.map(object => {
    if (!object.location?.latitude || !object.location?.longitude) return null;
    const position: LatLngTuple = [object.location.latitude, object.location.longitude];
    return (
      <Marker key={object.id} position={position}>
        <Popup className="text-base">
          <Link
            to={`/${projectId}/objects/${object.id}`}
            className="cursor-pointer hover:underline"
          >
            {object.title}
          </Link>
        </Popup>
      </Marker>
    );
  });

  return (
    <div>
      {mapMarkers}
      <ZoomControl position="bottomright" />
    </div>
  );
};

export default ObjectMapContent;